import {
  TASK_GET_NEXT,
  TASK_GET,
  TASK_ADD_CONTACT_INFO,
  TASK_SCHEDULE_CALLBACK,
  TASK_COMPLETE_VERIFICATION,
  TASK_CLOSE_VERIFICATION_THIRD_PARTY_VERIFIER,
  TASK_COMPLETE_TASK,
  TASK_ESCALATE,
  TASK_LOG_CALL,
  TASK_SKIP,
  TASK_SEND_AUTHORIZATION,
  TASK_START_IFRAME_SESSION_RECORDING,
  TASK_STOP_IFRAME_SESSION_RECORDING,
  TASK_EXTRACT_RECORDS,
  TASK_REQUEST,
  TASK_SUCCESS,
  TASK_ERROR,
} from '@/store/types'

import axios from '@/store/axios'


const state = {
  task: null,
  current: null,
  isLoading: false,
  error: null,
  sessionRecorder: null,
  sessionRecording: [],
}

const getters = {
  getTasks: (state) => state.tasks,
  getCurrentTask: (state) => state.current,
  isTaskLoading: (state) => state.isLoading,
  getTaskError: (state) => state.error,
}

const actions = {
  [TASK_GET_NEXT]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit(TASK_REQUEST)

      axios
        .get(`/api/v1a/agent_tasks/next/`)
        .then((resp) => {
          commit(TASK_SUCCESS, { current: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          commit(TASK_ERROR, err)
          reject(err)
        })
    })
  },
  [TASK_GET]: ({ commit }, { id }) => {
    return new Promise((resolve, reject) => {
      commit(TASK_REQUEST)

      axios
        .get(`/api/v1a/agent_tasks/${id}/`)
        .then((resp) => {
          commit(TASK_SUCCESS, { current: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          commit(TASK_ERROR, err)
          reject(err)
        })
    })
  },

  [TASK_ADD_CONTACT_INFO]: ({ commit }, { id, newContacts, removeCurrentNumber }) => {
    return new Promise((resolve, reject) => {
      commit(TASK_REQUEST)

      axios
        .post(`/api/v1a/agent_tasks/${id}/add_contact_info/`, {
          new_contacts: newContacts,
          remove_current_number: removeCurrentNumber,
          //internal_notes:
        })
        .then((resp) => {
          commit(TASK_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          commit(TASK_ERROR, err)
          reject(err)
        })
    })
  },
  [TASK_SCHEDULE_CALLBACK]: (
    { commit },
    { id, dateType, dateSpecific, timeType, timeSpecific, extensions },
  ) => {
    return new Promise((resolve, reject) => {
      commit(TASK_REQUEST)

      axios
        .post(`/api/v1a/agent_tasks/${id}/schedule_callback/`, {
          date_type: dateType,
          date_specific: dateSpecific,
          time_type: timeType,
          time_specific: timeSpecific,
          extensions,
        })
        .then((resp) => {
          commit(TASK_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          commit(TASK_ERROR, err)
          reject(err)
        })
    })
  },
  [TASK_COMPLETE_VERIFICATION]: ({ commit }, { id, resultData, closeNotes }) => {
    return new Promise((resolve, reject) => {
      commit(TASK_REQUEST)

      //internal_notes

      axios
        .post(`/api/v1a/agent_tasks/${id}/complete_order/`, {
          result_data: resultData,
          close_notes: closeNotes,
        })
        .then((resp) => {
          commit(TASK_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          commit(TASK_ERROR, err)
          reject(err)
        })
    })
  },
  [TASK_COMPLETE_TASK]: ({ commit, state }, { id, notes, resultData, uploadedReport }) => {
    return new Promise((resolve, reject) => {
      commit(TASK_REQUEST)

      if (uploadedReport) {
        const formData = new FormData()
        formData.append('internal_notes', notes)
        formData.append('report', uploadedReport)
        formData.append('result_data', JSON.stringify(resultData))
        formData.append('session_recording', state.sessionRecording)

        axios
          .post(`/api/v1a/agent_tasks/${id}/complete/`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((resp) => {
            commit(TASK_SUCCESS, { sessionRecording: [] })
            resolve(resp)
          })
          .catch((err) => {
            commit(TASK_ERROR, err)
            reject(err)
          })
      } else {
        axios
          .post(`/api/v1a/agent_tasks/${id}/complete/`, {
            internal_notes: notes,
            result_data: resultData,
            session_recording: state.sessionRecording,
          })
          .then((resp) => {
            commit(TASK_SUCCESS, { sessionRecording: [] })
            resolve(resp)
          })
          .catch((err) => {
            commit(TASK_ERROR, err)
            reject(err)
          })
      }
    })
  },
  [TASK_ESCALATE]: ({ commit, state }, { id, notes, escalateType }) => {
    return new Promise((resolve, reject) => {
      commit(TASK_REQUEST)

      axios
        .post(`/api/v1a/agent_tasks/${id}/escalate/`, {
          internal_notes: notes,
          escalate_type: escalateType,
          session_recording: state.sessionRecording,
        })
        .then((resp) => {
          commit(TASK_SUCCESS, { sessionRecording: [] })
          resolve(resp)
        })
        .catch((err) => {
          commit(TASK_ERROR, err)
          reject(err)
        })
    })
  },
  [TASK_LOG_CALL]: ({ commit }, { id, callId, callDisposition }) => {
    return new Promise((resolve, reject) => {
      // commit(TASK_REQUEST)

      axios
        .post(`/api/v1a/agent_tasks/${id}/log_call/`, {
          call_id: callId,
          call_disposition: callDisposition,
        })
        .then((resp) => {
          commit(TASK_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          commit(TASK_ERROR, err)
          reject(err)
        })
    })
  },
  [TASK_SKIP]: ({ commit }, { id }) => {
    return new Promise((resolve, reject) => {
      commit(TASK_REQUEST)

      axios
        .post(`/api/v1a/agent_tasks/${id}/skip/`)
        .then((resp) => {
          commit(TASK_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          commit(TASK_ERROR, err)
          reject(err)
        })
    })
  },
  [TASK_SEND_AUTHORIZATION]: ({ commit }, { id, sendType, faxNumber, email }) => {
    return new Promise((resolve, reject) => {
      commit(TASK_REQUEST)

      axios
        .post(`/api/v1a/agent_tasks/${id}/send_authorization/`, {
          send_type: sendType,
          fax_number: faxNumber,
          email,
        })
        .then((resp) => {
          commit(TASK_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          commit(TASK_ERROR, err)
          reject(err)
        })
    })
  },
  [TASK_CLOSE_VERIFICATION_THIRD_PARTY_VERIFIER]: (
    { commit },
    { id, verifier, verifierName, companyCode },
  ) => {
    return new Promise((resolve, reject) => {
      commit(TASK_REQUEST)

      axios
        .post(`/api/v1a/agent_tasks/${id}/close_order/`, {
          close_reason: 'third_party_verifier',
          verifier,
          verifier_name: verifierName,
          company_code: companyCode,
        })
        .then((resp) => {
          commit(TASK_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          commit(TASK_ERROR, err)
          reject(err)
        })
    })
  },
  [TASK_START_IFRAME_SESSION_RECORDING]: ({ commit, state }) => {
    return new Promise((resolve) => {
      console.log('start iframe recording!')
      const sessionRecorder = (event) => {
        // Ensure message is from our extension
        if (!event.data || event.data.type !== 'RRWEB_EVENT') {
          return
        }

        // (Optional) Check origin if necessary
        // if (this.allowedOrigins.length && !this.allowedOrigins.includes(event.origin)) return;

        const rrwebEvent = event.data.payload
        const sourceOrigin = event.data.origin

        state.sessionRecording.push(rrwebEvent)

        // Log for debugging
        console.log(`[Vue] Received event from ${sourceOrigin}`, rrwebEvent)
      }

      window.addEventListener('message', sessionRecorder)

      commit(TASK_SUCCESS, { sessionRecorder })
      resolve()
    })
  },
  [TASK_STOP_IFRAME_SESSION_RECORDING]: ({ commit, state }) => {
    return new Promise((resolve) => {
      console.log('stop iframe recording!')
      if (!state.sessionRecorder) {
        resolve()
        return
      }

      window.removeEventListener('message', state.sessionRecorder)

      commit(TASK_SUCCESS, { sessionRecorder: null })
      resolve()
    })
  },
  [TASK_EXTRACT_RECORDS]: ({ commit }, { uploadedReport }) => {
    return new Promise((resolve, reject) => {
      commit(TASK_REQUEST)
      const formData = new FormData()
      formData.append('file', uploadedReport)

      axios
        .post(`/api/v1a/agent_tasks/extract_records/`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((resp) => {
          commit(TASK_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          commit(TASK_ERROR, err)
          reject(err)
        })
    })
  },
}

const mutations = {
  [TASK_REQUEST]: (state) => {
    state.isLoading = true
  },
  [TASK_SUCCESS]: (state, { requests, current, sessionRecorder, sessionRecording } = {}) => {
    state.isLoading = false

    if (requests) {
      state.requests = requests
    }

    if (current !== undefined) {
      state.current = current
    }

    if (sessionRecorder !== undefined) {
      state.sessionRecorder = sessionRecorder
    }

    if (sessionRecording !== undefined) {
      state.sessionRecording = sessionRecording
    }
  },
  [TASK_ERROR]: (state, err) => {
    state.isLoading = false
    state.error = err
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
